export default __webpack_public_path__ + "static/media/background.0800ce7a.svg";